import { Input, InputProps } from "@chakra-ui/react";
import { forwardRef } from "react";

/** Shared field chrome for marketing forms (budget, schedule, creatives). */
const defaultFieldChrome: InputProps = {
  backgroundColor: "white",
  borderRadius: "md",
  borderWidth: "1px",
  borderColor: "gray.200",
  fontSize: "sm",
  _hover: { borderColor: "gray.300" },
  _focusVisible: {
    borderColor: "blue.500",
    boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)",
  },
  _invalid: {
    borderColor: "red.500",
    boxShadow: "0 0 0 1px var(--chakra-colors-red-500)",
  },
};

const WhiteBgInput = forwardRef<HTMLInputElement, InputProps>(
  (props, ref = null) => {
    return <Input ref={ref} {...defaultFieldChrome} {...props} />;
  }
);

WhiteBgInput.displayName = "WhiteBgInput";

export default WhiteBgInput;
